/** @module modules/notifications/locales/en */

export default {
  warning: 'Warning',
  error: 'Error',
  success: 'Success',
  info: 'Info',
}
